import * as React from "react";
import { LoadingSpinner } from "source/app/presentation/MainPanel/Calendar/LoadingSpinner";
import { FadeInText } from "source/app/presentation/Shared/Animation/FadeInArray";
import { Quote } from "source/app/presentation/Shared/Quote/Quote";
import { RenderDiv } from "source/app/presentation/Shared/Render";
import { Style } from "source/app/presentation/Shared/Styles/CSS";

export function LeadingQuote({
    isLoading,
    recordCount,
}: {
    isLoading: boolean;
    recordCount: number;
}) {
    return (
        <div
            {...Style(`dwkc_leadingQuoteHeight_${recordCount}`, {
                top: recordCount > 0 ? `0px` : `165px`,
                position: `relative`,
            })}
        >
            <Quote>
                <FadeInText
                    text="“ Only compare yourself to who you were yesterday, not who someone else is today ”"
                    characterDelayMs={50}
                />
            </Quote>
            <RenderDiv id="dwkc_loadingSpinner" when={isLoading}>
                <LoadingSpinner />
            </RenderDiv>
        </div>
    );
}
